import { Toast } from 'antd-mobile/2x';
import { ToastProps } from 'antd-mobile/es/components/toast/toast';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import Icon from '../components/Icon';

interface ToastContentProps {
  icon: 'success' | 'fail' | 'loading' | 'none' | 'cross' | 'alarm' | 'hand';
  content: React.ReactNode;
}

const genToastExtraContent = ({ icon, content }: ToastContentProps) => ({
  position: 'bottom' as ToastProps['position'],
  content: (
    <div className="custom-adm-content-wrapper">
      {!!icon && icon !== 'none' && (
        <div className="custom-adm-content-icon">
          {icon === 'loading' ? (
            <Loading3QuartersOutlined spin style={{ fontSize: '34px' }} />
          ) : (
            <Icon name={icon} size={24} />
          )}
        </div>
      )}
      <div className="custom-adm-content-text">{content}</div>
    </div>
  ),
});

class MyToast {
  success(content: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'success', content }),
      ...(config ? config : {}),
    });
  }
  fail(content: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'none', content }),
      ...(config ? config : {}),
    });
  }
  failIconCode(content: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'cross', content }),
      ...(config ? config : {}),
    });
  }
  loading(content?: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'loading', content }),
      ...(config ? config : {}),
    });
  }
  show(content?: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'none', content }),
      ...(config ? config : {}),
    });
  }
  showWithAlarm(content?: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'alarm', content }),
      ...(config ? config : {}),
    });
  }
  showWithEmphasis(content?: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'fail', content }),
      ...(config ? config : {}),
    });
  }
  showWithHand(content?: React.ReactNode, config?: Omit<ToastProps, 'content'>) {
    Toast.show({
      ...genToastExtraContent({ icon: 'hand', content }),
      ...(config ? config : {}),
    });
  }
  clear() {
    Toast.clear();
  }
}

export default new MyToast();
